// src/services/creditTopUpService.js
import api from "../utils/api";
import { API_CONFIG } from "../utils/apiConfig";

/**
 * Generate a Paystack payment link for a credit top-up.
 * @param {Object} params
 * @param {string|number} params.amount - The amount to top up (base currency)
 * @returns {Promise<{success:boolean, data:Object|null, error:string|null}>}
 */
export const generateCreditTopUpLink = async ({ amount }) => {
    try {
        const response = await api.post(API_CONFIG.PAYMENTS.CREDIT_TOPUP_GENERATE_LINK, { amount });
        const data = response.data;
        return {
            success: !!data?.success,
            data: data || null,
            error: null
        };
    } catch (error) {
        console.error("Error generating credit top-up link:", error);
        return {
            success: false,
            data: null,
            error: error.response?.data?.error || error.response?.data?.message || error.message || 'Failed to generate payment link'
        };
    }
};

/**
 * Verify a Paystack transaction for a credit top-up and, on success, the
 * backend credits the user's credit_balance.
 * @param {string} reference - The Paystack transaction reference
 * @returns {Promise<{success:boolean, data:Object|null, message:string|null}>}
 */
export const verifyCreditTopUp = async (reference) => {
    try {
        const response = await api.post(API_CONFIG.PAYMENTS.CREDIT_TOPUP_VERIFY, { reference });
        const data = response.data;
        return {
            success: !!data?.success,
            data: data || null,
            message: data?.message || null
        };
    } catch (error) {
        console.error("Error verifying credit top-up:", error);
        return {
            success: false,
            data: null,
            message: error.response?.data?.message || error.response?.data?.error || error.message || 'Failed to verify payment'
        };
    }
};
